import { render, staticRenderFns } from "./PhoneStepAccount.vue?vue&type=template&id=2c84d0a6&scoped=true"
import script from "./PhoneStepAccount.vue?vue&type=script&lang=js"
export * from "./PhoneStepAccount.vue?vue&type=script&lang=js"
import style0 from "./PhoneStepAccount.vue?vue&type=style&index=0&id=2c84d0a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c84d0a6",
  null
  
)

export default component.exports